import cloneDeep from 'lodash/fp/cloneDeep'
import {
  CLEAR_INVESTMENT_AMOUNT_CONTAINER,
  FETCH_KNOWS_HOW_MUCH_TO_INVEST_OPTIONS,
  FETCHING_KNOWS_HOW_MUCH_TO_INVEST_OPTIONS
} from './investmentAmountContainerActions'

const initialState = {
  knowsHowMuchToInvestOptionsLoading: false,
  knowsHowMuchToInvestOptions: []
}

export default function (state = initialState, action) {
  var oldState = state
  var newState = cloneDeep(oldState)
  switch (action.type) {
    case FETCH_KNOWS_HOW_MUCH_TO_INVEST_OPTIONS:
      newState.knowsHowMuchToInvestOptionsLoading = false
      newState.knowsHowMuchToInvestOptions = cloneDeep(action.payload)
      return newState
    case FETCHING_KNOWS_HOW_MUCH_TO_INVEST_OPTIONS:
      newState.knowsHowMuchToInvestOptionsLoading = true
      newState.knowsHowMuchToInvestOptions = []
      return newState
    case CLEAR_INVESTMENT_AMOUNT_CONTAINER:
      return cloneDeep(initialState)
  }
  return state
}

